import React, { useEffect, useRef, useState } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import FloatLabel from "../../../UiComponents/FloatLabel/FloatLabel";
import { Formik, Form, Field, ErrorMessage } from "formik";
import {
  PostBranch,
  UpdateBranch,
  SaveComissionReceivableAmount,
  GetCommisionReceivableAmount,
} from "../../../Service/_index";
import CloseIcon from "@mui/icons-material/Close";
import { ToastSuccess, ToastError } from "../../../UiComponents/Toaster/Toast";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import {
  DeleteIcon,
  EditIcon,
  CloudOffIcon,
} from "../../../Resources/Icons/icons";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { visuallyHidden } from "@mui/utils";
import Tooltip from "@mui/material/Tooltip";
import moment from "moment";
import Button from "@mui/material/Button";
import * as Yup from "yup";
import MasterCommonTable from "../../../UiComponents/CommonTable/MasterCommonTable";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Styles from "../CommonPayableDrawer/CommisionPayable.module.scss";
import { Link, useNavigate } from "react-router-dom";
import EditTransactionDialog from "./components/EditTransactionDialog";

function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis?.map((el) => el[0]);
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const headCells = [
  {
    id: "issueDate",
    placeMent: true,
    disablePadding: false,
    label: "Entry Date",
    type: "date",
    issueDateFormate: "L",
  },
  {
    id: "policyNumber",
    placeMent: true,
    disablePadding: false,
    label: "Policy Number",
  },
  {
    id: "bankName",
    placeMent: true,
    disablePadding: false,
    label: "Bank Name",
    minWidth: "150px",
  },
  {
    id: "amount",
    placeMent: true,
    disablePadding: false,
    label: "Amount",
    minWidth: "150px",
  },
  {
    id: "remark",
    placeMent: true,
    disablePadding: false,
    label: "Remarks",
    minWidth: "150px",
  },
  {
    id: "isBulkUpload",
    placeMent: true,
    disablePadding: false,
    label: "Is Bulk Upload",
    minWidth: "150px",
  }
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells?.map((headCell) => (
          <TableCell
            className="TableHeader"
            key={headCell.id}
            align={headCell.placeMent ? "left" : "center"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{ fontSize: "16px", fontWeight: 600 }}
            style={{ minWidth: headCells.minWidth }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
};

const ReceivedDrawer = (props) => {
  const {
    selectedData,
    formType,
    setOpenDrawer,
    title,
    GetData,
    showViewTrans,
    PendingFunction,
  } = props;
  let formRef = useRef();
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("id");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [transData, setFilterData] = useState([]);
  const [tableConfig, setTableConfig] = useState({
    isAction: false,
    isView: false,
    isEdit: false,
    isDelete: false,
    isSearch: false,
    isApprove: false,
  });
  const [filteredData, setFilteredData] = useState([]);
  // Transaction History rows can be edited (see EditTransactionDialog). The policy's
  // pending amount is kept in state because an edit changes it while this page stays
  // open - reading it straight from the selectedData prop would show a stale value.
  const [pendingAmountValue, setPendingAmountValue] = useState(
    selectedData?.commisionRecievable?.PendingAmount,
  );
  const [editTransaction, setEditTransaction] = useState(null);
  const historyTableConfig = {
    isAction: true,
    isEdit: true,
    isView: false,
    isDelete: false,
    isSearch: false,
    isApprove: false,
  };

  const initialValues = {
    entryDate: new Date(),
    bankName: "",
    remarks: "",
    receivedAmount: "",
    companyName: "",
    policyNumber: "",
    bookingCode: "",
    product: "",
    policyType: "",
  };

  const [filter, setFilter] = useState({
    fn: (items) => {
      return items;
    },
  });
  const visibleRows = React.useMemo(
    () =>
      stableSort(filter.fn(transData), getComparator(order, orderBy))?.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      ),
    [order, orderBy, page, rowsPerPage, filter, transData]
  );
  const navigate = useNavigate();
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - transData.length) : 0;
  const UserId = sessionStorage.getItem("UserId");

  const userDetails = [
    {
      label: "Dummy Login Id",
    },
  ];

  const GetHistoryData = () => {
    GetCommisionReceivableAmount(selectedData._id).then((res) => {
      setFilterData(res.data || []);
    });
  };

  const pendingLimit = Number(
    (pendingAmountValue === 0 ||
     pendingAmountValue === null ||
     pendingAmountValue === undefined)
      ? (selectedData?.commisionRecievable?.Total ?? 0)
      : pendingAmountValue
  );

  const handleEditTransaction = (row) => {
    setEditTransaction(row?.transaction || null);
  };

  // After an edit the policy's Received/Pending amounts have moved, so refresh the
  // history, this page's pending amount and the list behind it.
  const handleTransactionSaved = (result) => {
    const updatedPendingAmount = result?.PendingAmount;
    if (updatedPendingAmount !== undefined) {
      setPendingAmountValue(updatedPendingAmount);
      formRef?.setFieldValue?.("receivedAmount", Number(updatedPendingAmount));
    }
    GetHistoryData();
    PendingFunction();
  };

  const validationSchema = Yup.object().shape({
    receivedAmount: Yup.number()
      .required("Enter Amount")
      .typeError("Total must be a number"),
  });

  useEffect(() => {
    GetHistoryData();
    if (formType === "edit") {
      Object.keys(initialValues).forEach((el) => {
        if (selectedData[el]) {
          initialValues[el] = selectedData[el];
        }
      });
      initialValues.policyNumber = selectedData?.policyNumber;
      initialValues.companyName =
        selectedData?.companyId?.companyName ||
        selectedData?.companyId?.shortName;
      initialValues.bookingCode = selectedData?.bookingCodeId?.bookingCode;
      initialValues.product = selectedData?.productId?.product;
      initialValues.policyType = selectedData?.policyTypeId?.policyType;
      const pendingAmount = selectedData?.commisionRecievable?.PendingAmount;
      initialValues.receivedAmount = Number(
        (pendingAmount === 0 || pendingAmount === null || pendingAmount === undefined)
          ? (selectedData?.commisionRecievable?.Total ?? 0)
          : pendingAmount
      );
    }
    formRef.setValues(initialValues);
  }, []);

  const onSubmit = (e) => {
    e.policyId = selectedData?._id;
    SaveComissionReceivableAmount(selectedData._id, e)
      .then((res) => {
        ToastSuccess("Received Succesfully");
        PendingFunction();
        setOpenDrawer(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    // console.log("policyList: ", policyList);
    setFilteredData(
      transData.map((data) => ({
        issueDate: data?.entryDate,
        policyNumber: data?.policyNumber,
        bankName: data?.bankName,
        amount: data?.receivedAmount,
        isBulkUpload: data?.isBulkUpload ? "Yes" : "No",
        remark: data?.remarks,
        // kept on the row so the Edit action knows which transaction to update
        transaction: data,
      }))
    );
  }, [transData]);
  console.log("filteredData: ", filteredData);

  return (
    <>
      <div className={Styles.MainRenderinContainer}>
        <Stack direction={"row"} alignItems={"center"}>
          <div className="breadcrumb" style={{ marginLeft: "33px" }}>
            <a
              className="text-color"
              onClick={() => {
                navigate("/dashboard");
              }}
              style={{ cursor: "pointer" }}
            >
              {"Home"}
            </a>
            <span
              style={{
                padding: "0px 10px 0px 10px",
              }}
            >
              <ArrowForwardIosIcon
                style={{
                  fontSize: "13px",
                }}
              />
            </span>
            <a
              className="text-color"
              onClick={() => {
                setOpenDrawer(false);
              }}
              style={{ cursor: "pointer" }}
            >
              {"Utilites"}
            </a>
            <span
              style={{
                padding: "0px 10px 0px 10px",
              }}
            >
              <ArrowForwardIosIcon
                style={{
                  fontSize: "13px",
                }}
              />
            </span>
            <a className="text-color">{"View Utilites"}</a>
            <span
              style={{
                padding: "0px 10px 0px 10px",
              }}
            >
              <ArrowForwardIosIcon
                style={{
                  fontSize: "13px",
                }}
              />
            </span>
          </div>
        </Stack>

        <div className={Styles.formContainer}>
          <Grid container className="DrawerHeader">
            <Grid item xs={6} sm={6}>
              <Typography>Received Transaction</Typography>
            </Grid>
            <Grid item xs={6} sm={6} className="d-flex justify-content-end">
              <CloseIcon
                onClick={() => setOpenDrawer(false)}
                sx={{ cursor: "pointer" }}
              />
            </Grid>
          </Grid>

          <div className="container-fluid">
            <Formik
              initialValues={initialValues}
              onSubmit={(values) => {
                onSubmit(values);
              }}
              innerRef={(ref) => {
                if (ref) {
                  formRef = ref;
                }
              }}
              validationSchema={validationSchema}
            >
              {({ values, setFieldValue, errors, touched }) => (
                <Form>
                  <Grid 
                  container 
                  columnSpacing={12}
                  rowSpacing={2}
                  >
                    <Grid item xs={12} sm={6}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Policy Number
                      </Typography>
                      <Field
                        name="policyNumber"
                        className="InputFiled"
                        value={values.policyNumber}
                        style={{ textTransform: "uppercase" }}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Company Name
                      </Typography>
                      <Field
                        name="companyName"
                        className="InputFiled"
                        style={{ textTransform: "uppercase" }}
                        value={values.companyName}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Booking Code
                      </Typography>

                      <Field
                        name="bookingCode"
                        className="InputFiled"
                        value={values.bookingCode}
                        style={{ textTransform: "uppercase" }}
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Entry Date
                      </Typography>

                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          name="entryDate"
                          className="w-100 Date_Picker"
                          defaultValue={dayjs()}
                          onChange={(e) => setFieldValue("entryDate", e.$d)}
                        />
                      </LocalizationProvider>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Bank
                      </Typography>
                      <Field
                        name="bankName"
                        className="InputFiled"
                        value={values?.bankName}
                        style={{ textTransform: "uppercase" }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                        Remark
                      </Typography>
                      <Field
                        name="remarks"
                        className="InputFiled"
                        value={values?.remarks}
                        style={{ textTransform: "uppercase" }}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <Typography
                        className={Styles.inputTitle}
                        sx={{ fontSize: "12px", mb: 1 }}
                      >
                      {`Amount (${pendingLimit})`}
                      </Typography>

                      <Field
                        name="receivedAmount"
                        className="InputFiled"
                        value={values.receivedAmount}
                        style={{ textTransform: "uppercase" }}
                      />

                      <div className="errorMessage">
                        {errors.receivedAmount && touched.receivedAmount ? (
                          <div>{errors.receivedAmount}</div>
                        ) : (
                          " "
                        )}
                      </div>
                    </Grid>
                    {showViewTrans ? (
                      Number(values.receivedAmount) !== 0 && (
                        <Grid item xs={12} sm={6}>
                          <Button
                            type="submit"
                            sx={{
                              marginTop: "28px",
                            }}
                          >
                            Submit
                          </Button>
                        </Grid>
                      )
                    ) : (
                      Number(values.receivedAmount) !== 0 && (
                        <Grid
                          className="Dialog_Footer"
                          item
                          xs={12}
                          sm={12}
                          gap={1}
                        >
                          <Button
                            className="Dialog_Cancel"
                            sx={{
                              marginTop: "28px",
                            }}
                            onClick={() => setOpenDrawer(false)}
                          >
                            Cancel
                          </Button>
                          <Button
                            className="Dialog_Save_Exit"
                            type="submit"
                            sx={{
                              marginTop: "28px",
                            }}
                          >
                            {selectedData?._id ? "Update" : "Save"}
                          </Button>
                        </Grid>
                      )
                    )}
                  </Grid>
                </Form>
              )}
            </Formik>
            <hr style={{ display: showViewTrans ? "block" : "none" }} />
            {showViewTrans ? (
              <div>
                <Typography mt={2} mb={2}>
                  Transaction History
                </Typography>
                <MasterCommonTable
                  tableConfig={historyTableConfig}
                  data={filteredData}
                  columns={headCells}
                  handleEdit={handleEditTransaction}
                  tableTotalCount={filter.fn(transData)?.length || 0}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>

      <EditTransactionDialog
        open={Boolean(editTransaction)}
        transaction={editTransaction}
        pendingAmount={pendingLimit}
        onClose={() => setEditTransaction(null)}
        onSaved={handleTransactionSaved}
      />
    </>
  );
};

export default ReceivedDrawer;
